const KEY = 'vediluxe_recently_viewed';
const MAX = 12;

export const getRecentlyViewedIds = (): string[] => {
  try {
    const raw = localStorage.getItem(KEY);
    const ids = raw ? JSON.parse(raw) : [];
    return Array.isArray(ids) ? ids.filter((id) => typeof id === 'string') : [];
  } catch {
    return [];
  }
};

/** Most-recent first, deduped, capped at MAX. */
export const trackProductView = (productId: string) => {
  if (!productId) return;
  try {
    const ids = [productId, ...getRecentlyViewedIds().filter((id) => id !== productId)].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(ids));
  } catch {
    // Storage unavailable (private mode etc.) — tracking is best-effort
  }
};
